import { Typography, defaultTheme } from '@agro-club/agroclub-shared'
import { isRussia } from 'env'
import { BidTypes } from 'modules/domain/bid/types'
import { isSaleBid } from 'modules/domain/bid/utils'
import { refetchFunc } from 'modules/domain/common/hooks'
import { Deal } from 'modules/domain/deal/types'
import { getAddressKeysByType, useAddressFormatter } from 'modules/domain/logisticsKR/utils'
import { Address } from 'modules/domain/types'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import { AddressExtraInfo } from 'views/components/AddressTitle/AddressTitle'
import { BorderedItem } from 'views/components/BorderedItem/BorderedItem'
import { KeyValue } from 'views/components/KeyValue/KeyValue'
import { WarehouseEditAction } from './WarehouseEditAction'
import { getDealBid } from 'modules/domain/deal/utils'

const WarehouseInfoWrapper = styled.div`
  display: flex;
  margin-right: 93px;
  color: ${defaultTheme.color.textPrimary900};
  ${Typography.bodyLarge};
`
const MarginBlock = styled.div`
  margin-top: 8px;
`

type Props = {
  deal: Deal
  bidType: BidTypes
  refetch: refetchFunc
}

export const BidDetailAddress: FC<Props> = ({ deal, bidType, refetch }) => {
  const bid = getDealBid(deal, bidType)

  const { t } = useTranslation('deal')
  const formatter = useAddressFormatter()

  const address = bid.address as Address
  const isSale = isSaleBid(bid)
  const addressLabel = isSale ? t('fields.loading_address') : t('fields.unloading_address')

  const addressKeys: string[] = getAddressKeysByType(isSale)

  const addressWarehouseInfo = formatter(address, addressKeys).join(', ')

  return (
    <>
      <KeyValue label={addressLabel}>
        <AddressExtraInfo address={address} />
        <div>{address.address}</div>
        {isRussia && (
          <MarginBlock>
            <BorderedItem hover={false}>
              <KeyValue label={t('address:editAddressParams')}>
                <WarehouseInfoWrapper>{addressWarehouseInfo}</WarehouseInfoWrapper>
              </KeyValue>
              <WarehouseEditAction deal={deal} refetch={refetch} bidType={bidType} />
            </BorderedItem>
          </MarginBlock>
        )}
      </KeyValue>
    </>
  )
}
